import React from 'react'
import Modal from 'react-modal'

import useHomepage from '../../hooks/useHomepage'
import CateringDeliveryConfirmation from './components/CateringDeliveryConfirmation'
import CateringDeliveryForm from './components/CateringDeliveryForm'
import CookiesModal from './components/Cookies/CookiesModal'
import GetAccessForm from './components/GetAccessForm'
import LaunchingSoonConfirmation from './components/LaunchingSoonConfirmation'
import OneDollarLunchPromo from './components/OneDollarLunchPromo'
import SelectCityModal from './components/SelectCityModal'

interface ModalProps {
  settings: any
  onClose: () => void
  onSubmit: () => void
}

type ModalsType = {
  [key: string]: React.FC<ModalProps>
}

const modals: ModalsType = {
  'select-city': SelectCityModal,
  'launching-soon-confirmation': LaunchingSoonConfirmation,
  'get-access-form': GetAccessForm,
  'catering-delivery-form': CateringDeliveryForm,
  'catering-delivery-confirmation': CateringDeliveryConfirmation,
  'one-dollar-lunch-promo': OneDollarLunchPromo,
  cookies: CookiesModal,
}

const Container = () => {
  const { currentModal, hideModal } = useHomepage()

  const onSubmitHandler = (callback: () => void) => {
    return () => {
      if (callback) {
        callback()
      }

      hideModal(currentModal.name)
    }
  }

  const onCloseHandler = (callback: () => void) => {
    return () => {
      if (callback) {
        callback()
      }

      hideModal(currentModal.name)
    }
  }

  if (currentModal === null) {
    return <></>
  }

  const { name, settings, onSubmit, onClose } = currentModal
  const OpenModal = modals[name]

  return (
    <Modal
      ariaHideApp={false}
      isOpen={true}
      shouldCloseOnOverlayClick={false}
      className="modal"
      overlayClassName="modal__overlay"
    >
      <OpenModal settings={settings} onSubmit={onSubmitHandler(onSubmit)} onClose={onCloseHandler(onClose)} />
    </Modal>
  )
}

export default Container
